import { LoraApiClient } from '../services/api/lora';

let client: LoraApiClient;

const loraFactory = () => (client = new LoraApiClient());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getLoraApi = (): LoraApiClient => client ?? loraFactory();
